"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.containsString = containsString;
exports.createSearch = exports._buildSearchProps = exports._sort = exports._addToSearchTerms = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

require("../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context12; (0, _forEach.default)(_context12 = ownKeys(Object(source), true)).call(_context12, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context13; (0, _forEach.default)(_context13 = ownKeys(Object(source))).call(_context13, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

/**
 * @method
 * @name _addToSearchTerms
 * @param {object} node
 * @private
 * @desc Adds item label and keywords to search terms
 */
var _addToSearchTerms = function _addToSearchTerms(_ref) {
  var _context, _context2, _context3;

  var id = _ref.id,
      label = _ref.label,
      _ref$keywords = _ref.keywords,
      keywords = _ref$keywords === void 0 ? [] : _ref$keywords;
  var searchTerms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _reduce.default)(_context = (0, _filter.default)(_context2 = (0, _concat.default)(_context3 = [label]).call(_context3, keywords)).call(_context2, function (key) {
    return key.length > 1;
  })).call(_context, function (acc, keyword) {
    var _context4;

    var lowerKey = keyword.toLowerCase();
    var _acc$lowerKey = acc[lowerKey],
        currentKeyValues = _acc$lowerKey === void 0 ? [] : _acc$lowerKey;
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty3.default)({}, lowerKey, (0, _concat.default)(_context4 = [id]).call(_context4, currentKeyValues)));
  }, searchTerms);
};
/**
 * @method
 * @name _addSearchProps
 * @param {object} node
 * @param {object} possibleResults
 * @param {object} searchTerms
 * @private
 * @desc Return search terms and results for a tree node recursively
 */


exports._addToSearchTerms = _addToSearchTerms;

var _getSearchProps = function _getSearchProps(_ref2, possibleResults, searchTerms) {
  var id = _ref2.id,
      label = _ref2.label,
      root = _ref2.root,
      section = _ref2.section,
      _ref2$keywords = _ref2.keywords,
      keywords = _ref2$keywords === void 0 ? [] : _ref2$keywords,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? [] : _ref2$children;
  // Give children information on their parents. Setting section
  // on end nodes doesn't matter because they have no children.
  var ancestorProps = root && !section && children.length > 0 ? {
    root: root,
    section: {
      id: id,
      label: label
    }
  } : {
    root: root
  }; // Get results and search terms for all children

  var _children$reduce = (0, _reduce.default)(children).call(children, function (_ref3, child) {
    var accResults = _ref3.possibleResults,
        accSearch = _ref3.searchTerms;
    return _getSearchProps(_objectSpread(_objectSpread({}, child), ancestorProps), accResults, accSearch);
  }, {
    possibleResults: possibleResults,
    searchTerms: searchTerms
  }),
      newResults = _children$reduce.possibleResults,
      childSearchTerms = _children$reduce.searchTerms;

  var result = {
    hasChildren: children.length > 0,
    id: id,
    label: label,
    root: root,
    section: section
  };
  var isEndNode = !!section || root && children.length === 0;
  return {
    // Don't add results unless they're end nodes
    possibleResults: isEndNode ? _objectSpread((0, _defineProperty3.default)({}, id, _objectSpread({}, result)), newResults) : newResults,
    searchTerms: isEndNode ? _addToSearchTerms(_objectSpread({
      id: id,
      keywords: keywords
    }, result), childSearchTerms) : childSearchTerms
  };
};

var _getResults = function _getResults(possibleResults, ids) {
  var currentResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _reduce.default)(ids).call(ids, function (acc, id) {
    var _context5;

    return (0, _some.default)(currentResults).call(currentResults, function (current) {
      return id === current.id;
    }) ? acc : (0, _concat.default)(_context5 = [possibleResults[id]]).call(_context5, acc);
  }, []);
};

var _sort = function _sort(_ref4, _ref5) {
  var a = _ref4.id;
  var b = _ref5.id;
  return a > b ? 1 : -1;
};
/**
 * @method
 * @name _buildSearchProps
 * @param {array} tree
 * @private
 * @desc Return the results lookup and the keyword lookup for search
 */


exports._sort = _sort;

var _buildSearchProps = function _buildSearchProps(tree) {
  return (0, _reduce.default)(tree).call(tree, function (_ref6, _ref7) {
    var possibleResults = _ref6.possibleResults,
        searchTerms = _ref6.searchTerms;
    var id = _ref7.id,
        label = _ref7.label,
        children = _ref7.children;
    return (0, _reduce.default)(children).call(children, function (_ref8, child) {
      var accResults = _ref8.possibleResults,
          accSearch = _ref8.searchTerms;
      return _getSearchProps(_objectSpread(_objectSpread({}, child), {}, {
        root: {
          id: id,
          label: label
        }
      }), accResults, accSearch);
    }, {
      possibleResults: possibleResults,
      searchTerms: searchTerms
    });
  }, {
    possibleResults: {},
    searchTerms: {}
  });
};
/**
 * @method
 * @name _checkForMatch
 * @param {object} searchTerms
 * @param {object} possibleResults
 * @param {string} query
 * @private
 * @desc Checks for a match against provided search terms and possible results; curried so that factory can use it.
 */


exports._buildSearchProps = _buildSearchProps;

var _checkForMatch = function _checkForMatch(searchTerms) {
  return function (possibleResults) {
    return function (query) {
      var _context6;

      var _Object$keys$reduce = (0, _reduce.default)(_context6 = (0, _keys.default)(searchTerms)).call(_context6, function (_ref9, key) {
        var startsAcc = (0, _startsWith.default)(_ref9),
            containsAcc = _ref9.contains;
        // Return all results for empty query
        var keyIndex = query ? (0, _indexOf.default)(key).call(key, query.toLowerCase()) : 0; // Put results that start with the search term before results that just contain it.

        if (keyIndex === 0 || !query) {
          var _context7, _context8;

          var idResults = searchTerms[key];
          return {
            startsWith: (0, _concat.default)(_context7 = []).call(_context7, startsAcc, _getResults(possibleResults, idResults, (0, _concat.default)(_context8 = []).call(_context8, startsAcc, containsAcc))),
            contains: containsAcc
          };
        } else if (keyIndex > 0) {
          var _context9, _context10;

          var _idResults = searchTerms[key];
          return {
            startsWith: startsAcc,
            contains: (0, _concat.default)(_context9 = []).call(_context9, containsAcc, _getResults(possibleResults, _idResults, (0, _concat.default)(_context10 = []).call(_context10, startsAcc, containsAcc)))
          };
        } else {
          return {
            startsWith: startsAcc,
            contains: containsAcc
          };
        }
      }, {
        startsWith: [],
        contains: []
      }),
          startsWith = (0, _startsWith.default)(_Object$keys$reduce),
          contains = _Object$keys$reduce.contains;

      return {
        startsWith: startsWith,
        contains: contains
      };
    };
  };
};
/**
 * @method
 * @name createSearch
 * @param {array} tree
 * @public
 * @desc Returns a function that searches the nodes of a given tree based on the provided string query.
 */


var createSearch = function createSearch() {
  var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _buildSearchProps2 = _buildSearchProps(tree),
      possibleResults = _buildSearchProps2.possibleResults,
      searchTerms = _buildSearchProps2.searchTerms;

  return [_checkForMatch(searchTerms)(possibleResults), possibleResults];
};

exports.createSearch = createSearch;

var getSearchableContent = function getSearchableContent(string) {
  // Some searchable labels might contain JSX. If they do, convert them to a string and then
  // strip out the markup with the regex below.
  if ( /*#__PURE__*/_react.default.isValidElement(string)) {
    var asString = _server.default.renderToStaticMarkup(string);

    return asString.replace(/(<([^>]+)>)/ig);
  } else {
    return string;
  }
}; // Would use string.contains() here, but Jest doesn't like it. Probably related to our Node.js version.


function containsString(string, searchTerm) {
  var _context11;

  var searchable = getSearchableContent(string);
  return (0, _indexOf.default)(_context11 = searchable.toLowerCase()).call(_context11, searchTerm.toLowerCase()) > -1;
}